export const IDLE_STATE_REACHED = 'idle-state-reached';
